export default "__VITE_ASSET__D8gi1BlG__"